import Exim from 'exim';
import _ from 'lodash';
import Api from 'tm3-core/api';
import { cache } from 'tm3-core/cache';
import ModuleEnum from 'tm3-core/licence';
import lazy from './lazy-loader';

const LabelAPI = {
  cache: {},

  loadAll() {
    return lazy('/api/sys/labels/all');
  },

  resetCache() {
    lazy.clear('/api/sys/labels/all');
    return lazy('/api/sys/labels/all');
  },

  get(label) {
    return this.loadAll().then(function (res) {
      let val = __guard__(
        _.filter(res.body.results, { id: label.toUpperCase() })[0],
        (x) => x.text
      );
      if (val == null) {
        val = label;
      }
      return val;
    });
  }
};

const saveLabels = (labels) =>
  Api.post('/api/settings/labels/save', { labels }).then(() => {
    return LabelAPI.resetCache();
  });
const debouncedSave = _.debounce(saveLabels, 1000);

export default Exim.createStore({
  actions: ['loadAll', 'load', 'set', 'newLoad'],

  initial: {
    loadingLabels: true,
    labels: {},
    allLabels: [
      { id: 'ADDR1', niceName: 'Address:', text: 'Address:' },
      {
        id: 'ADDR2',
        niceName: 'Address 2:',
        text: 'Address 2:'
      },
      { id: 'ADDR3', niceName: 'Town:', text: 'Town:' },
      { id: 'ADDR4', niceName: 'County:', text: 'County:' },
      { id: 'ADDR5', niceName: 'Country:', text: 'Country:' },
      {
        id: 'ADDRPC',
        niceName: 'Postcode:',
        text: 'Postcode:'
      },
      {
        id: 'PATAREF',
        niceName: 'Alt Reference:',
        text: 'Alt Reference:'
      },
      {
        id: 'PATEMPLY',
        niceName: 'Employer:',
        text: 'Employer:',
        module: ModuleEnum.ContactsAdvanced
      },
      {
        id: 'PATHOSCD',
        niceName: 'Hospital Code:',
        text: 'Hospital Code:',
        module: ModuleEnum.ContactsAdvanced
      },
      {
        id: 'PATNICD',
        niceName: 'NI Number:',
        text: 'NI Number:',
        module: ModuleEnum.ContactsAdvanced
      },
      {
        id: 'PATPLCY',
        niceName: 'Policy No:',
        text: 'Policy No:',
        module: ModuleEnum.ContactsAdvanced
      }
    ]
  },

  load(label) {
    return LabelAPI.get(label).then((res) => {
      return this.set({ [label]: res });
    });
  },

  newLoad(label) {
    return LabelAPI.get(label).then((res) => {
      return res;
    });
  },

  loadAll() {
    this.set({ loadingLabels: true });
    return LabelAPI.loadAll().then((res) => {
      let allLabels = this.get('allLabels');

      for (let label of res.body.results) {
        const selected = _.filter(allLabels, { id: label.id })[0];
        if (selected != null) {
          selected.text = label.text;
        }
      }
      this.set({ allLabels });
      return this.set({ loadingLabels: false });
    });
  },

  set(label, value) {
    const allLabels = this.get('allLabels');
    const selected = _.filter(allLabels, { id: label })[0];
    if (selected != null) {
      selected.text = value;
    } else {
      allLabels.push({ id: label, value });
    }
    debouncedSave(allLabels);
    return this.set({
      allLabels,
      savingLabels: true
    });
  }
});

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
